import React, {useState, useEffect } from "react";

function PaginationFooter({ pagination, updatePagination }) {
  if(pagination.total === 0) return null;

  const start = (pagination.page - 1) * pagination.perPage + 1;
  const end = Math.min(start + pagination.perPage - 1, pagination.total)
  const total = pagination.total.toLocaleString()

  const showNext = ((pagination.page - 1) * pagination.perPage + pagination.perPage) < pagination.total
  const showPrevious = pagination.page > 1;

  return (
    <div className='flex items-center justify-between'>
      <p className="text-sm text-gray-700">
        Showing <span className="font-medium">{start}</span>{" "}
        to <span className="font-medium">{end}</span>{" "}of{" "}
        <span className="font-medium">{total}</span>{" "}results
      </p>
      <div className='text-right'>
        {
          showPrevious && (
            <button className='relative inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0'
                    onClick={(e) => {
                      e.preventDefault();
                      if(pagination.page > 1) {
                        updatePagination(pagination.page - 1)
                      }
                    }}
            >
              Previous
            </button>
          )
        }

        {
          showNext && (
            <button className='ml-3 relative inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0'
                    onClick={(e) => {
                      e.preventDefault();
                      updatePagination(pagination.page + 1)
                    }}
            >
              Next
            </button>
          )
        }
      </div>
    </div>
  )
}

export default PaginationFooter;